module.exports = __webpack_public_path__ + "assets/white-left-arrow-hp-db23c6.svg";